export default {
  colors: [
    ['#F86C6B', '#ea587c', '#cef46b', '#0dcc4b', '#FFA500'],
    ['#4DBD74', '#63C2DE', '#d28906', '#d4061b', '#01e1eb']
  ]
}



// WEBPACK FOOTER //
// ./src/_colors.js